import { render, staticRenderFns } from "./LandingHero.vue?vue&type=template&id=70ddb2b3&scoped=true"
import script from "./LandingHero.vue?vue&type=script&lang=js"
export * from "./LandingHero.vue?vue&type=script&lang=js"
import style0 from "./LandingHero.vue?vue&type=style&index=0&id=70ddb2b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ddb2b3",
  null
  
)

export default component.exports